// dataReducer.js
import {
  FETCH_REQUEST,
  FETCH_SUCCESS,
  FETCH_FAILURE,
} from "../Actions/actionTypes";

const initialState = {
  dropdownData: {
    loading: false,
    data: {
      participants: [],
      placeOfServiceCode: [],
      primaryTargetAreas: [],
      behaviorInterventions: [],
      maladaptiveBehaviors: [],
      reinforcers: [],
      skillStrategies: [],
      clientMoods: [],
      sessionStartGreetings: [],
      sessionEndComments: [],
      nextSessionPlans: [],
    },
    error: null,
  },
  clientData: {
    loading: false,
    data: [],
    error: null,
  },
};

const dataReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        [action.entity]: {
          ...state[action.entity],
          loading: true,
        },
      };
    case FETCH_SUCCESS:
      //console.log(action.entity, action.payload, "in reducer");
      newState = {
        ...state,
        [action.entity]: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
      //console.log("Dropdown Reducer - New State:", newState);
      return newState;
    case FETCH_FAILURE:
      return {
        ...state,
        [action.entity]: {
          loading: false,
          data: state[action.entity].data,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default dataReducer;
